import React from 'react'
import { useTheme } from '@mui/material'

export const RoofAnglesIcon = (props: {
  angle?: number
  knee_wall?: string
}) => {
  const theme = useTheme()
  const stroke = theme.palette.primary.active

  return (
    <svg
      aria-hidden='true'
      className='roof-visualization'
      focusable='false'
      height='74'
      role='img'
      viewBox='0 0 136 74'
      width='136'
      xmlns='http://www.w3.org/2000/svg'>
      <g fill='none' transform='translate(-1 2)'>
        {props.knee_wall && (
          <text fill='#BEBEBE' fontSize='10'>
            <tspan x='0' y='59'>
              {props.knee_wall}
            </tspan>
          </text>
        )}
        <path d='M44 9l12-9 60 44v28H44V9z' fill='#F7F7F7' />
        <path
          d='M43.274 8.796L55.348.2l63.926 45.511'
          stroke={stroke}
          strokeOpacity='.5'
          strokeWidth='3'
        />
        <path d='M74.5 45.5h40.043' stroke='#BEBEBE' strokeLinecap='square' />
        <path d='M44.5 63.5h72' stroke='#FFF' strokeLinecap='square' />
        <path d='M85.704 23a38.377 38.377 0 0 0-7.247 22.5' stroke='#BEBEBE' />
        <path
          d='M41.5 45.5h14m-14 18h14m-12-18v18.028'
          stroke='#BEBEBE'
          strokeLinecap='square'
        />
        {props.angle && (
          <text fill='#BEBEBE' fontSize='10'>
            <tspan x='98' y='16'>{`${props.angle}º`}</tspan>
          </text>
        )}
      </g>
    </svg>
  )
}
